<template>
    <div>
        <loading v-if="showLoading"></loading>
        <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>
        <account-status :account_status="account_status"></account-status>

        <div class="widget has-shadow">

            <div class="widget-header bordered  d-flex align-items-center">
                <h2>قیمت گذاری محصولات</h2>
            </div>

            <div class="widget-body">
                <div v-if="show_alert_message" style="margin-bottom:10px" class="alert alert-success alert-dismissible fade show" role="alert">
                    <span>{{ alert_message }}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                </div>

                <div class="product_search_div">
                    <form method="get" class="search_form package_search_box">
                        <input type="text" class="form-control" v-model="search_text" placeholder="نام محصول ..">
                        <a class="btn btn-primary" v-on:click="getProduct(1)" style="color:white">جست و جو</a>
                    </form>
                </div>

                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>تصویر محصول</th>
                        <th>عنوان</th>
                        <th>کمترین قیمت</th>
                        <th>تعداد فروشنده</th>
                        <th>تعداد تنوع قیمت</th>
                        <th width="150">عمیات</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(product,key) in ProductList.data" v-bind:key="key">
                        <td>
                            {{ getRow(key) }}
                        </td>
                        <td>
                            <img v-bind:src="$siteUrl+'/files/product/350/'+product.img" class="product_pic">
                        </td>
                        <td>
                            <ul>
                                <li>
                                    {{ product.name }}
                                </li>
                                <li>
                                    {{ product.ename }}
                                </li>
                            </ul>
                        </td>
                        <td>
                            <div v-if="product.get_warranty_count>0">
                                <span>{{ replaceNumber(number_format((product.price))) }} تومان</span>
                            </div>
                        </td>
                        <td>
                            {{ getSellerCount(product) }}
                        </td>
                        <td>
                            {{ replaceNumber(product.get_warranty_count) }}
                        </td>
                        <td style="width:150px">
                            <button class="btn btn-success" v-on:click="add(product.id)">من هم میفروشم</button>
                        </td>
                    </tr>
                    <tr v-if="ProductList.data.length==0">
                        <td colspan="7">محصولی یافت نشد</td>
                    </tr>
                    </tbody>
                </table>
                <pagination :data="ProductList" @pagination-change-page="getProduct"></pagination>
            </div>
        </div>


        <div class="message_div" v-if="showMessageDialog">
            <div class="message_box">
                <p id="msg">آیا از حذف این محصول مطمئن هستین ؟</p>
                <a class="alert alert-success" v-on:click="remove_product_of_list">بله</a>
                <a class="alert alert-danger" v-on:click="showMessageDialog=!showMessageDialog">خیر</a>
            </div>
        </div>
        <server-error-message v-if="server_error"></server-error-message>

    </div>
</template>

<script>
import myMinix from '../myMixin';
export default {
    mixins:[myMinix],
    data(){
        return {
            show_product_list:false,
            server_error:false,
            showLoading:true,
            ProductList:{data:[]},
            BreadcrumbList:[
                { path:'/products',title:'مدیریت محصولات' },
                {path:'/products/all',title:'قیمت گذاری محصولات'}
            ],
            productStatusClass:[
                'alert alert-danger',
                'alert alert-warning',
                'alert alert-secondary',
                'alert alert-primary',
                'alert alert-success',
            ],
            search_text:'',
            page:1,
            account_status:'active',
            seller_id:-1,
            showMessageDialog:false,
            delete_product_id:0,
            show_alert_message:false,
            alert_message:'',
            search_title:''
        }
    },
    mounted(){
        this.seller_id=localStorage.getItem('seller_id');
        if(this.$route.params.success=='ok')
        {

            this.show_alert_message=true;
            if(this.$route.params.message!=undefined)
            {
                this.alert_message=this.$route.params.message;
            }
            else{
                this.alert_message='ثبت قیمت با موفقیت انجام شد';
            }
        }
        this.account_status=localStorage.getItem('account_status');
        this.$emit('setSideBarItem','products');
        this.getProduct();
    },
    methods:{
        getProduct:function(page=1){
            this.page=page;
            this.showLoading=true;
            const url=this.$siteUrl+'/api/seller/total_product?page='+page+'&search_text='+this.search_text;
            this.axios.get(url,this.setHeader()).then(response=>{
                this.showLoading=false;
                const result=this.setAccountStatus(response.data);
                if(result)
                {
                    this.ProductList=response.data;
                }
                
            }).catch((error)=>{
                this.setCatch(error);
            });
        },
        getSellerCount:function(product)
        {
            let n=parseInt(product.seller_list_count);
            if(product.digi_warranty!=null)
            {
                n++;
            }
            if(product.get_warranty_count==0)
            {
                n=0;
            }
            return this.replaceNumber(n);
        },
        add:function(product_id)
        {
            this.$router.push({name:'addProductWarranty',params:{id:product_id}});
        }
    }
}
</script>

<style>

</style>